import { getAllByTiers } from '@/api/contacts';
import store from '@/store/store';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';

function getInfomationsFromContact(contact) {
  const typesContactParam = store.getters['parametres/parametre'](PARAMETRES_KEYS.typeContact);
  let typeContact = '';
  if (contact.typesContactIds) {
    const filter = typesContactParam.filter(el => contact.typesContactIds.includes(el.id));
    if (filter.length > 0) typeContact = filter.map(f => f.libelle).join(', ');
  }
  return {
    id: contact.id,
    email: contact.email,
    nomToDisplay: nomPrenomGetter(contact)
      + (contact.email ? ' - ' + contact.email : '')
      + (contact.service ? ' - ' + contact.service : '')
      + (contact.fonction ? ' - ' + contact.fonction : '')
      + (typeContact ? ' - ' + typeContact : ''),
    nom: contact.nom,
    prenom: contact.prenom,
    archive: contact.archive,
  };
}

export default async function getInfoContactsMail(intervenants, title) {
  let contactsByTiers = [];
  const promiseContacts = [];
  intervenants.forEach((intervenant) => {
    promiseContacts.push(getAllByTiers(intervenant.tiersId));
  });
  contactsByTiers = (await Promise.all(promiseContacts))
    .map((rslt) => rslt.data.result.items);
  await store.dispatch('parametres/loadParametres', [PARAMETRES_KEYS.typeContact]);
  const contactsInfo = [];

  const infoIntervenant = {
    nomCommercial: title ?? null,
    contacts: intervenants
      .filter(i => i.intervenantContacts)
      .map(i => i.intervenantContacts
        ?.filter(ic => ic.contact?.email)
        ?.map(ic => {
          const contact = ic.contact;
          contact.typesContactIds = ic.contactTypes.map(ct => ct.typeContactId);
          return getInfomationsFromContact(contact);
        }),
      ).flat(2),
  };

  if (infoIntervenant.contacts.length !== 0) {
    contactsInfo.push(infoIntervenant);
  }

  contactsByTiers.forEach((tiers) => {
    const infoGroup = {
      nomCommercial: null,
      contacts: [],
    };
    if (tiers.length === 0) return;
    infoGroup.nomCommercial = intervenants.find((intervenant) => {
      return intervenant.tiersId === tiers[0].tiersId;
    }).nomCommercial;
    infoGroup.contacts = tiers
      .filter((contact) => {
        const intervenantinfo = contactsInfo.find(ci => ci.nomCommercial === title);
        if (intervenantinfo) {
          return !contact?.archive && contact?.email
            && !intervenantinfo?.contacts.map(c => c.id)?.includes(contact.id);
        }
        return !contact?.archive && contact?.email;
      })
      .map((contact) => getInfomationsFromContact(contact));
    if (infoGroup.contacts.length > 0) contactsInfo.push(infoGroup);
  });
  return contactsInfo;
}
